export default "__VITE_ASSET__RpihXTw4u4VVDOtP81WECA__";